import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { HeaderNavi } from '../../components/navigation'
import { loginLogoIcon } from '../../icons'
import { LOGIN } from '../../constants/Paths'
import { removeSession } from '../../modules/common/session'
import '../Login/Login.css'

const LoggedOut = () => {
  useEffect(() => {
    removeSession()
  }, [])

  return (
    <div className="login-content">
      <HeaderNavi />
      <div className="mamorio-login-form mamorio-login-status">
        <img src={loginLogoIcon} className="mamorio-login-logo" alt="office-logo" />
        <h1 className="mamorio-login-status-title">
          ログアウトしました
        </h1>
        <p className="mamorio-login-status-message">
          再度利用する場合は、ログインしてください。
        </p>
        <Link
          to={LOGIN}
          className="btn btn-primary btn-lg mamorio-login-status-action"
          data-testid="login-again-link"
        >
          再ログイン
        </Link>
      </div>
    </div>
  )
}

export default LoggedOut
